/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { IUiPermissionApiItem } from '@models/user-permission.model';
import { CompanyTypesEnum } from '@truckstop-tms/zuum-lib';

export const loadUiPermissions = createAction(
  '[Settings:User Page] Load Ui Permission',
  props<{ companyType: CompanyTypesEnum; tmsEnabled: boolean }>()
);
export const loadUiPermissionsSuccess = createAction(
  '[Settings:User Page] Load Ui Permission Success',
  props<{ permissions: IUiPermissionApiItem[] }>()
);
export const loadUiPermissionsFailure = createAction(
  '[Settings:User Page] Load Ui Permission Failure',
  props<{ errorMessage: string }>()
);
